
import React from "react";
import { gsap } from "gsap";
import "./App.css";
import Navbar from "./component/Navbar";
import Home from "./component/Home";
import { Routes, Route} from 'react-router-dom';
import Contact from './component/Contact'
import About from'./component/About';
import cauzenlogo from './assest/CauZen Logo 01.png'
import Footer from "./component/Footer";
import SolutionPage from "./component/Service";
import Hero from "./component/Hero";
import ProductDetail from './component/ProductDetail';
import Solutiongallery from "./component/Solutiongallery";
import Career from "./component/Career";
import Mainpage from "./component/mainpage";
import ComingSoon from "./component/ComingSoon";





const App = () => {
  return (
    <>
       <Navbar />
        
             <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
       <Route path="/contact" element={<Contact/>}/>
       <Route path="/service" element={<SolutionPage/>}/>
        <Route path="/hero" element={<Hero />} />
     <Route path="/career"element={<Career/>}/>
      <Route path="/mainpage"element={<Mainpage/>}/>
       <Route path="/gallery"element={<Solutiongallery/>}/>
       <Route path="/coming-soon" element={<ComingSoon/>}/>
  <Route path="/product/:id" element={<ProductDetail />} />

      </Routes>
      <Footer/>
    
    </>
  )
}

export default App

